import React from 'react';
import { 
  FileCopy 
} from '@mui/icons-material';

import BaseButton from './BaseButton';

interface Props extends React.ComponentPropsWithoutRef<'div'> {
  disabled?: boolean;
  label?: string;
  label_separate?: boolean;
  no_fab?: boolean;
  fab?: boolean;
  link_url?: string;
  log_it?: boolean;
  onClick: (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement> | undefined) => void;
  onMouseDown?: (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement>) => void;
}

export default function CopyButton(props: Props) {
  const pass_along_props = {...props};
  return (
    <BaseButton
      icon={<FileCopy />}
      {...pass_along_props}
    />
  );
}
